var domainPj = 'https://profejobs-dev.web.app';

export const globals = {
    path_module_teacher: {
        sing_in: domainPj + '/profesor/login',
        sing_up: domainPj + '/profesor/registro-basico',
        search_job: domainPj + '/anuncios',
        landing: 'tutor/landing',
        categories: 'categories',
        view: 'tutor/profile',
    },
    path_module_common: {
        home: '',
        faq: 'faq',
        support: 'support',
        not_found: 'not-found'
    },
    pattern: {
        email: /^(([^<>()[\]\\.,;:\s@\"\x80-\xff]+(\.[^<>()[\]\\.,;:\s@\"\x80-\xff]+)*)|(\"[^\x80-\xff]+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        pass: /^(?=\D*\d)(?=[^A-Z]*[A-Z]).{6,30}$/,
        phone: '[\+][5]{1}[6]{1}[9]{1}[0-9]{8}',
        phone_8digits: '[0-9]{8}',
        url: /^(?:(http(s)?)?(sftp)?(ftp)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
    },
    job_hour_range:
    {
        min: 0,
        max: 45,
        step: 1,
        limit: 5
    },

    employer_enrollment_quantity:
    {
        range: {
            'min': 1,
            '8%': 251,
            '17%': 501,
            '33%': 1001,
            '67%': 2001,
            '92%': 3001,
            'max': 3002,
        },
        margin:
            [
                { value: 1, margin: 250 },
                { value: 251, margin: 250 },
                { value: 501, margin: 500 },
                { value: 1001, margin: 1000 },
                { value: 2001, margin: 999 },
                { value: 3001, margin: 0 },
                { value: 3002, margin: 0 },
            ]
    },
    employer_teacher_quantity:
    {
        range: {
            'min': 1,
            '12%': 26,
            '23%': 51,
            '34%': 76,
            '45%': 101,
            '56%': 126,
            '67%': 151,
            '78%': 176,
            '89%': 201,
            'max': 202,
        },
        margin:
            [
                { value: 1, margin: 25 },
                { value: 26, margin: 25 },
                { value: 51, margin: 25 },
                { value: 76, margin: 25 },
                { value: 101, margin: 25 },
                { value: 126, margin: 25 },
                { value: 151, margin: 25 },
                { value: 176, margin: 25 },
                { value: 201, margin: 0 },
                { value: 202, margin: 0 },

            ]

    },
    employer_student_per_class: { min: 1, max: 50, step: 1 },
    experience_employer: { min: 0, max: 30, step: 1 },
    experience_year: { min: 0, max: 40, step: 1 },
    language_level: { min: 0, max: 4, step: 1 },
    language_level_search: { min: 1, max: 4, step: 1 },
    enrollment_admin_search: { min: 0, max: 5000, step: 100 },
    filter_employee_age: { min: 20, max: 100, step: 1 },
    priority_employee: { min: 0, max: 5, step: 1 },
    job_salary_range: { min: 0, max: 3000000, step: 50000, limit: 300000 },
    md5:
    {
        key: 'LTdxZfemnSdDIhsDeaKea'
    },
    social_media: {
        facebook: 'https://www.facebook.com/ProfeJobs-101431195148330',
        instagram: 'https://www.instagram.com/profejobs.cl/?hl=es-la',
        linkedin: 'https://www.linkedin.com/company/profejobs/?viewAsMember=true',
    },
    days_of_week: [
        { key: 'L', name: 'Lunes' },
        { key: 'M', name: 'Martes' },
        { key: 'W', name: 'Miércoles' },
        { key: 'J', name: 'Jueves' },
        { key: 'V', name: 'Viernes' },
        { key: 'S', name: 'Sábado' },
        { key: 'D', name: 'Domingo' },
    ]

};